import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCollect } from 'contracts/Collects';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_COLLECTS_',
  }
);

export interface ListCollectsState {
  data: ListedCollect[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCollectsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCollect[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCollectsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCollectsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListCollectsState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListCollectsState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCollectsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const ListCollects = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCollectsTypes = Types;
export const ListCollectsActions = Creators;
